import { useDocumentCreationRelationship } from 'support/helpers/relationships/relationships';
import { DocumentType } from 'support/types';
import { BasePopup } from 'components/Display/BasePopup/BasePopup';

import { SetupOCRExtractor } from './SetupOCRExtractor/SetupOCRExtractor';

type OCRSetupModalProps = {
  setOpen: (open: boolean) => void;
  open: boolean;
  sourceMessageId: string;
  documentType: DocumentType | undefined;
};

export const OCRSetupModal = ({ open, setOpen, sourceMessageId, documentType }: OCRSetupModalProps) => {
  const targetRelationship = useDocumentCreationRelationship({
    sourceMessageId,
    documentType,
  });

  if (!targetRelationship) {
    return null;
  }

  return (
    <BasePopup setOpen={setOpen} open={open} width="fit-content" shouldGrowIndefinitely>
      <SetupOCRExtractor targetRelationship={targetRelationship} setOpen={setOpen} />
    </BasePopup>
  );
};
